import { getRuntimeConfig } from '../../lib/runtimeConfig';
import { buildCompanyContactUrl } from '../../helpers/urls';

/* istanbul ignore next */
const publicRuntimeConfig = getRuntimeConfig() || {};

const testContact = {
  country_code: 'US',
  email_address: 'mikaela.smith@procore.com',
  email_signature: 'Sent From Procore.',
  first_name: 'Mikaela',
  is_active: true,
  is_employee: true,
  last_login_at: '2025-06-12T14:51:24Z',
  last_name: 'Smith',
  party_id: 34529939,
  created_at: '2025-04-03T23:56:38Z',
  updated_at: '2025-04-03T23:56:48Z',
  is_insurance_manager: false,
  id: 7596349,
  initials: 'MK',
  name: 'Mikaela Smith',
  login_information_uuid: '105b1f05-8f26-4881-8bdf-6129ca289033',
};

export default async function getCompanyContact(companyId: number) {
  if (publicRuntimeConfig.mockUserPersona && !publicRuntimeConfig.isProd) {
    return testContact;
  }
  const url = buildCompanyContactUrl(companyId);
  if (!url) {
    return null;
  }
  const result = await fetch(url, {
    credentials: 'include',
    mode: 'cors',
  });
  if (result.ok) {
    return await result.json();
  }
  return null;
}
